// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"bbc4c4f4","325":"88cf8856","404":"0ea90795","418":"7eafb3cf","428":"2c56c4eb","486":"5cf1b797","494":"935a4ef2","588":"ff3afd8e","683":"7c4257ee","735":"e97004f8","775":"fde0cb5f","906":"582a7d20","956":"39799452","973":"74479bbc"}[chunkId] + ".chunk.js";
};